import { Control, Controller, FieldPath, FieldValues } from "react-hook-form";
import { DatePicker, DateValue } from "component-library";
import { useTranslation } from "react-i18next";

type ControlledDatePickerProps<F extends FieldValues, N> = {
  control: Control<F>;
  name: N;
  label?: string;
  required?: string;
};

export const ControlledDatePicker = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>(
  props: ControlledDatePickerProps<TFieldValues, TName>,
) => {
  const { t } = useTranslation();
  return (
    <Controller
      name={props.name}
      control={props.control}
      rules={{
        validate: (value: DateValue) => {
          if (!props.required) {
            return true;
          }

          if (value.day && value.month && value.year) {
            return true;
          }
          return props.required;
        },
      }}
      render={({ field, fieldState }) => (
        <DatePicker
          translations={{
            months: {
              january: t("components.date_picker.months.january"),
              february: t("components.date_picker.months.february"),
              march: t("components.date_picker.months.march"),
              april: t("components.date_picker.months.april"),
              may: t("components.date_picker.months.may"),
              june: t("components.date_picker.months.june"),
              july: t("components.date_picker.months.july"),
              august: t("components.date_picker.months.august"),
              september: t("components.date_picker.months.september"),
              october: t("components.date_picker.months.october"),
              november: t("components.date_picker.months.november"),
              december: t("components.date_picker.months.december"),
            },
            placeholders: {
              day: t("components.date_picker.day_placeholder"),
              month: t("components.date_picker.month_placeholder"),
              year: t("components.date_picker.year_placeholder"),
            },
          }}
          value={field.value}
          onChange={field.onChange}
          label={props.label}
          error={fieldState.error?.message}
        />
      )}
    />
  );
};
